"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALIDATE_CLINICAL_COSIGNER_RESPONSE_EXAMPLE = exports.RESOLVE_CLINICAL_APPROVAL_CHAIN_RESPONSE_EXAMPLE = void 0;
const clinical_common_response_1 = require("./clinical-common.response");
exports.RESOLVE_CLINICAL_APPROVAL_CHAIN_RESPONSE_EXAMPLE = [
    clinical_common_response_1.CLINICAL_APPROVAL_CHAIN_STEP_RESPONSE_EXAMPLE,
];
exports.VALIDATE_CLINICAL_COSIGNER_RESPONSE_EXAMPLE = {
    allowed: true,
    chain: [clinical_common_response_1.CLINICAL_APPROVAL_CHAIN_STEP_RESPONSE_EXAMPLE],
};
//# sourceMappingURL=clinical-approval.response.js.map